module.exports = "data:image/gif;base64,R0lGODlhCgAKAOMCANfX16Ojo////+Dg4Onp6ebm5tra2uXl5efn5+Li4v///////////////////////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACwAAAAACgAKAAAEIBDISau9mA4hDKdBIIQCGAyhQRVHspUTgRwkRRBFOFARADs="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/sizer/ne-handle.gif
 ** module id = 493
 ** module chunks = 0
 **/